import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * Reusable geometric morphing-box loader (inspired by uiverse.io/alexruix/neat-tiger-82).
 * Pure CSS animation — three outlined boxes rearrange inside a square stage.
 */
@Component({
  selector: 'app-morph-box-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './morph-box-loader.component.html',
  styleUrl: './morph-box-loader.component.scss',
})
export class MorphBoxLoaderComponent {
  /** Optional status text shown under the animation. */
  @Input() message = '';
  /** Visual size of the 112×112 stage (px). */
  @Input() size = 112;
  /** Border/outline color (defaults to brand purple via CSS). */
  @Input() color = '';
}
